/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { CardsItem } from "./cards-item";
import { useWindowSize } from "cms/hooks/use-window-size";
import { CarouselWithNav } from "cms/shared/carousel-with-nav";

const CardsComponent = (props) => {

    const { component } = props;
    const { card_list: cardList, sectionName, subtitle, title } = component || {};

    const { width: screenWidth } = useWindowSize();

    const mobileBreakpoint = 545;
    const isDesktop = screenWidth > mobileBreakpoint;
    const cardsItemWidthDesktop = 408;
    const cardsItemWidthMobile = 300;
    const cardsItemWidth = isDesktop ? cardsItemWidthDesktop : cardsItemWidthMobile;
    const cardsItemGap = 16;

    const cardsItemStyle = {
        minWidth: `${cardsItemWidth}px`,
        width: `${cardsItemWidth}px`
    };

    const renderCardsItem = (cardsItem) => {
        return <CardsItem item={cardsItem} style={cardsItemStyle} />;
    };

    return (
        <div className={"cards-component"}>
            {sectionName && <h4>{sectionName}</h4>}
            {title && <h2>{title}{subtitle && <span>{` ${subtitle}`}</span>}</h2>}

            <CarouselWithNav
                carouselItemList={cardList}
                carouselItemWidth={cardsItemWidth}
                carouselItemGapOverride={cardsItemGap}
                renderCarouselItem={renderCardsItem}
            />

        </div>
    );
};

CardsComponent.displayName = "CardsComponent";
export { CardsComponent };
